import script from "./AppFeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./AppFeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./AppFeedbackView.vue?vue&type=style&index=0&id=4f15615a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f15615a"]])

export default __exports__